import { ABodyColor, ABodySize } from '../../atoms/ABody';

export enum MBlockquoteAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface MBlockquoteProps extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: MBlockquoteAlignment;
  quoteIcon?: boolean;
  blockquoteText?: string;
  bodyText?: string;
  bodyColor?: ABodyColor;
  bodySize?: ABodySize;
}
